import { useState } from 'react';
import { UserCheck, UserX } from 'lucide-react';
import { toast } from '@/components/ui/toaster.jsx';
import { decidePossibleMatch } from '@/services/queue.service.js';

// R6 (people-create-door, PLAN-ROUND3 1.3 and 1.7): David answers a possible_match
// row, two person records that may be one person (an email is a delivery address,
// never identity, David 2026-10-20). One component, on the queue page and the
// deal panel (and later the People to confirm block, which imports it). Same
// person on a separate record MOVES its pilot form onto the existing record (Q23
// yes, David 2026-10-21; no Contacts are merged); anything else is recorded only.
// The server reads the row back; the toast says the answer the ROW holds, never
// the button pressed. Every warning the answer carries is its own toast.info. An
// answered row (409 already_answered) or a refused move (the row stays open) is
// the server's sentence. onDone gets the answer the row holds (null when none was
// read back) and the server's answer, so the block can show the next step.

const YOU_SAID = { same: 'You said: same person', different: 'You said: not the same' };
// Q36: a Same person tap on a record on a deal's roster swaps the roster too (the server's roster_swap.done).
const SWAP_WORDS = { Approved_Pilots: 'the deal roster', quotes: 'quotes', excluded_pilots: 'exclusions', 'submissions.pilots': 'submissions' };
const answerOf = (resolvedBy) => {
  const m = /^(same|different):/.exec(String(resolvedBy || ''));
  return m ? m[1] : null;
};

export default function PossibleMatchButtons({ item, onDone, compact = false }) {
  const [busy, setBusy] = useState(false);
  const id = item.refs?.notification_id;
  if (!id) return null;

  async function answer(a) {
    setBusy(true);
    let stored = null;
    let r = null;
    try {
      r = await decidePossibleMatch(id, a);
      stored = answerOf(r.item?.resolved_by);
      if (stored) toast.success(YOU_SAID[stored]);
      else toast.info('The answer was sent; it could not be read back. Read the queue again.');
      const swapped = [...new Set((r.roster_swap?.done || []).map((x) => SWAP_WORDS[x.store] || x.store))];
      if (swapped.length) toast.info(`The roster now names the existing record on: ${swapped.join(', ')}.`);
      for (const w of r.warnings || []) toast.info(typeof w === 'string' ? w : (w.message || w.code));
    } catch (err) {
      toast.error(err.body?.error || err.message || 'Could not record the answer');
    } finally {
      setBusy(false);
      onDone?.(stored, r);
    }
  }

  const cls = compact
    ? 'inline-flex min-h-[32px] shrink-0 items-center gap-1 rounded-[5px] border border-border px-2 py-1 text-[12px] text-text-muted hover:border-border-strong hover:text-text disabled:opacity-50'
    : 'inline-flex min-h-[36px] shrink-0 items-center gap-1 rounded-[5px] border border-border bg-surface px-2.5 py-1.5 text-[12.5px] text-text-muted hover:border-border-strong hover:text-text disabled:opacity-50';
  const size = compact ? 13 : 14;
  return (
    <span className="inline-flex shrink-0 items-center gap-1.5">
      <button type="button" title="These two records are the same person (a pilot form on the separate record moves onto the existing one; no records are merged)" disabled={busy} onClick={() => answer('same')} className={cls}>
        <UserCheck size={size} strokeWidth={1.5} /> Same person
      </button>
      <button type="button" title="These two records are different people" disabled={busy} onClick={() => answer('different')} className={cls}>
        <UserX size={size} strokeWidth={1.5} /> Not the same
      </button>
    </span>
  );
}
